export default "__VITE_ASSET__f9ae8906__"